<template>
  <signup-layout>
    <p class="header-text">Create Your Account</p>
    <img
      class="-ml-3 w-full"
      src="@/assets/tracker-signup.svg"
      alt="sign up tracker"
    />
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <div>
        <p class="mt-6 text-1lg text-dark-blue">Verification</p>
        <p class="my-2 text-left text-sm text-dark-gray">
          Enter the code we just sent to the mobile number you entered.
        </p>
        <div
          class="mb-3 flex flex-row gap-2 rounded-lg border border-pumpkin-400 bg-pumpkin-100 p-2 text-left"
        >
          <div>
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.2699 3.82273C9.03875 2.49138 10.9612 2.49138 11.7294 3.82273L16.6254 12.3087C17.3936 13.64 16.4324 15.3042 14.8953 15.3042H5.10397C3.56693 15.3042 2.60637 13.64 3.37455 12.3087L8.26923 3.82273H8.2699ZM9.99998 7.3155C10.1324 7.3155 10.2594 7.3681 10.353 7.46173C10.4466 7.55536 10.4992 7.68234 10.4992 7.81475V10.311C10.4992 10.4434 10.4466 10.5704 10.353 10.664C10.2594 10.7577 10.1324 10.8103 9.99998 10.8103C9.86757 10.8103 9.74058 10.7577 9.64695 10.664C9.55332 10.5704 9.50072 10.4434 9.50072 10.311V7.81475C9.50072 7.68234 9.55332 7.55536 9.64695 7.46173C9.74058 7.3681 9.86757 7.3155 9.99998 7.3155ZM9.99998 12.8073C10.1324 12.8073 10.2594 12.7547 10.353 12.6611C10.4466 12.5674 10.4992 12.4404 10.4992 12.308C10.4992 12.1756 10.4466 12.0486 10.353 11.955C10.2594 11.8614 10.1324 11.8088 9.99998 11.8088C9.86757 11.8088 9.74058 11.8614 9.64695 11.955C9.55332 12.0486 9.50072 12.1756 9.50072 12.308C9.50072 12.4404 9.55332 12.5674 9.64695 12.6611C9.74058 12.7547 9.86757 12.8073 9.99998 12.8073Z"
                fill="#FF9330"
              />
            </svg>
          </div>
          <p class="text-xs font-normal text-pumpkin-900">
            Highway will never call you for your verification code. Please do
            not share with anyone that asks for your code.
          </p>
        </div>
        <form-field
          label="Verification Code"
          :value="phone_twilio_validation"
          placeholder="Enter Verification Code"
          :on-input="onInput"
          name="phone_twilio_validation"
          :is-valid="!error"
          error-message="Incorrect verification code"
        />
        <div class="flex-col sm:flex">
          <button-main
            class="my-4 mb-4"
            :disabled="!phone_twilio_validation"
            type="submit"
            value="Continue"
          >
            Continue
          </button-main>
          <div class="mt-2 text-center sm:mt-4">
            <p class="mb-2 text-1md text-body-color">Code didn't send?</p>
            <p
              class="cursor-pointer text-1md text-yellow-500 sm:mb-4"
              @click="() => createVerification()"
            >
              Try Again
            </p>
          </div>
        </div>
      </div>
    </form>
  </signup-layout>
</template>

<script type="text/javascript">
import { toastResponse } from '@/common/handleServerResponse';
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';
import SignupLayout from '@/components/layouts/SignupLayout.vue';

// import {
//   formatPhoneParenthesis,
//   formatFirstLastName,
// } from "@/common/validators";

export default {
  name: 'My Profile Verification',
  components: {
    ButtonMain,
    FormField,
    SignupLayout,
  },
  data() {
    return {
      error: false,
      phone_twilio_validation: '',
    };
  },
  computed: {
    shouldShowLegalAgreements() {
      return !this.$store.getters['users/hasConsentedToLegalAgreements'];
    },
    // currentUser(){
    //   return this.$store.state.users.currentUser;
    // },
    // needsPhone(){
    //   return this.$store.state.users.currentUser?.phone_e164 == null;
    // },
    // needsName(){
    //   return this.$store.state.users.currentUser?.first_name == null;
    // },
    currentVerification() {
      return this.$store.state.verifications.currentVerification;
    },
    phoneNumber() {
      return this.$store.state.signUpData.phone_number;
    },
  },
  methods: {
    onInput(e) {
      this.phone_twilio_validation = e.target.value;
    },
    async handleSubmit() {
      const res = await this.$store.dispatch(
        'verifications/confirmVerification',
        {
          code: this.phone_twilio_validation,
          verification_id: this.currentVerification.id,
        }
      );

      if ([200, 201].includes(res.status)) {
        // verification code is valid
        // run check for open user invitation
        this.validation_error = false;
        const userUpdateResult = await this.$store.dispatch(
          'users/updatePhoneWithVerification',
          this.currentVerification.id
        );

        // Handle TOTP setup redirect if qr_code is returned
        if (
          userUpdateResult.data?.qr_code?.length > 0 &&
          userUpdateResult.data?.setup_key?.length > 0
        ) {
          this.$store.commit('setTOTPData', {
            qrCode: userUpdateResult.data.qr_code,
            setupKey: userUpdateResult.data.setup_key,
          });
          return this.$router.push({ name: 'SecurityRegisterDevice' });
        }

        await this.$store.dispatch(
          'users/getFeatureFlags',
          userUpdateResult.data
        );

        if (userUpdateResult.status == 200) {
          let redirectAfterSignIn = JSON.parse(
            localStorage.getItem('redirect_url_after_sigin')
          );

          // If they came in through the OAuth process,
          // then then they will be redirected to the /oauth/authorizations
          // endpoint with the correct credentials

          const sendToIDV = this.$store.getters['users/getFeatureFlag']?.(
            'idv_onboarding_flow'
          )?.enabled;

          let fallbackRouteName = 'Home';

          if (sendToIDV) {
            fallbackRouteName = 'IdentityVerification';
          } else {
            // 2. Fallback based on company type
            const companyType =
              this.$store.state.users.currentUser.company.company_type;

            if (companyType === 'broker')
              fallbackRouteName = 'Broker Dashboard';
            else if (companyType === 'carrier')
              fallbackRouteName = 'CarrierWelcomePage';
            else if (companyType === 'dispatcher')
              fallbackRouteName = 'Dispatcher Dashboard';
          }
          // Case 1: `redirectAfterSignIn` exists and policies are verified
          if (redirectAfterSignIn && !this.shouldShowLegalAgreements) {
            console.log(
              'Redirecting to redirectAfterSignIn, policies verified'
            );
            localStorage.removeItem('redirect_url_after_sigin'); // Remove item after use
            return this.$router.push(redirectAfterSignIn);
          }

          // Case 2: `redirectAfterSignIn` exists but policies are NOT verified
          if (redirectAfterSignIn && this.shouldShowLegalAgreements) {
            console.log('Redirecting to LegalAgreements for verification');
            return this.$router.push({
              name: 'LegalAgreements',
              query: {
                redirectTo: sendToIDV ? 'IdentityVerification' : undefined,
              },
            });
          }

          // Case 3: `redirectAfterSignIn` does NOT exist and policies are NOT verified
          if (!redirectAfterSignIn && this.shouldShowLegalAgreements) {
            console.log('Redirecting to LegalAgreements with fallback query');
            return this.$router.push({
              name: 'LegalAgreements',
              query: { redirectTo: fallbackRouteName }, // Use `fallbackRoute` as `redirectTo`
            });
          }

          // Case 4: `redirectAfterSignIn` does NOT exist and policies are already verified
          console.log('Redirecting to fallback route, policies verified');
          return this.$router.push({
            name: sendToIDV ? 'IdentityVerification' : fallbackRouteName,
          });
        } else {
          toastResponse(this, res, null);
        }
      } else if (res.status === 422) {
        this.validation_error = true;
        toastResponse(this, res, null);
      } else {
        this.validation_error = false;
        toastResponse(this, res, null);
      }
    },
    async createVerification() {
      const res = await this.$store.dispatch(
        'verifications/createVerification',
        this.phone_number
      );
      if (![200, 201].includes(res.status)) {
        toastResponse(this, res, null);
      }
    },
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}
</style>
